
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.333 5.625H16.01c-.5 0-.751 0-.987-.071-.236-.072-.445-.21-.862-.489-.625-.417-1.338-.892-1.693-1-.354-.107-.73-.107-1.48-.107-1.023 0-1.681 0-2.14.19-.46.191-.822.552-1.544 1.275l-.636.636c-.163.163-.244.244-.295.324a.833.833 0 00.052.957c.059.075.148.147.328.292a1.66 1.66 0 002.22-.124L10 6.473h.833l5 5.03a1.19 1.19 0 010 1.677 1.173 1.173 0 01-1.666 0l-.417-.42m0 0l-2.5-2.514m2.5 2.514a1.19 1.19 0 010 1.677 1.174 1.174 0 01-1.667 0l-.833-.838m0 0a1.19 1.19 0 010 1.676 1.174 1.174 0 01-1.667 0l-1.25-1.257m2.917-.42l-1.667-1.666m-1.25 2.086l-.416-.42m.416.42a1.19 1.19 0 010 1.676 1.174 1.174 0 01-1.666 0l-2.353-2.402c-.484-.493-.726-.74-1.035-.87-.31-.13-.656-.13-1.347-.13h-.265","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.333 12.292H16.25M7.083 5.625H1.667","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    